import { render, staticRenderFns } from "./childarea.vue?vue&type=template&id=88c01ef6&scoped=true"
import script from "./childarea.vue?vue&type=script&lang=js"
export * from "./childarea.vue?vue&type=script&lang=js"
import style0 from "./childarea.vue?vue&type=style&index=0&id=88c01ef6&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "88c01ef6",
  null
  
)

export default component.exports